import axios from 'axios';
const successCode = [200];
const successCodeTwo = [200, -4];

const baseUrl = process.env.NODE_ENV === "development" ? '/todo/index.php' : 'http://todo.kairusi.cn/index.php/';
const baseUrlTwo = process.env.NODE_ENV === "development" ? '/todo/index.php' : 'http://todo.kairusi.cn/index.php';

const post = (url, params) => {
    const goalUrl = baseUrl + url;
    const body = JSON.stringify(params);
    const headers = {
        'content-type': 'application/json;charset=UTF-8',
        'product': 'dbclock_pc'
    };
    const options = { method: 'POST', body, headers };
    return fetch(goalUrl, options)
        .then(statusCheck)
        .then(parseJSON)
        .then(resultCheck);
}

const activePost = (url, params) => {
    const options = {
        method: 'post',
        url: `${baseUrlTwo}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'charset': 'utf-8',
            // 'SESSIONID': userInfo.session_id,
            "PRODUCT": "dbclock_pc",
            "deviceidtype": "pc"
        }
    };
    return axios(options).then(statusCheck).then(resultCheckTwo)
};

function statusCheck(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new Error(response.statusText || '服务异常！');
    error.response = response;
    throw error;
}

function parseJSON(response) {
    return response.json();
}

function resultCheck(data) {
    if (successCode.includes(data.res)) return data;
    const error = new Error(data.msg || '服务异常！');
    error.response = data;
    throw error;
}
const resultCheckTwo = (response) => {
    if (successCodeTwo.includes(response.data.res)) return response.data;
    let content = "";
    if (response.data.res === -2) {
        content = "您还不是VIP，升级会员后可享受所有功能";
    } else if (response.data.res === -1) {
        content = "请重新登录！";
    } else {
        content = response.data.msg || '服务异常！';
    }
    // message.destroy();
    if (response.data.res === -2) {

    } else {
        // message.warning({
        //     duration: 2,
        //     content: content,
        //     className: 'custom-class',
        // });
    }
    throw new Error(content);
}

export {
   post,
   activePost,
}